import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1242.35294,677.647059 L1242.35294,1920 L0,1920 L0,677.647059 L1242.35294,677.647059 Z M1129.41176,790.588235 L112.941176,790.588235 L112.941176,1807.05882 L1129.41176,1807.05882 L1129.41176,790.588235 Z M338.823529,1129.41176 L903.529412,1129.41176 L903.529412,1016.47059 L338.823529,1016.47059 L338.823529,1129.41176 Z M338.823529,1581.17647 L903.529412,1581.17647 L903.529412,1468.23529 L338.823529,1468.23529 L338.823529,1581.17647 Z M1581.17647,338.823529 L1581.17647,1581.17647 L1355.29412,1581.17647 L1355.29412,1468.23529 L1468.23529,1468.23529 L1468.23529,451.764706 L451.764706,451.764706 L451.764706,564.705882 L338.823529,564.705882 L338.823529,338.823529 L1581.17647,338.823529 Z M790.701176,1242.35294 L790.701176,1355.29412 L338.823529,1355.29412 L338.823529,1242.35294 L790.701176,1242.35294 Z M1920.03388,-0.0112941176 L1920.03388,1242.34165 L1694.15153,1242.34165 L1694.15153,1129.40047 L1807.09271,1129.40047 L1807.09271,112.929882 L790.622118,112.929882 L790.622118,225.871059 L677.680941,225.871059 L677.680941,-0.0112941176 L1920.03388,-0.0112941176 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconCollectionLine = /*#__PURE__*/function (_Component) {
  _inherits(IconCollectionLine, _Component);

  var _super = _createSuper(IconCollectionLine);

  function IconCollectionLine() {
    _classCallCheck(this, IconCollectionLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconCollectionLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconCollection",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconCollectionLine.displayName = "IconCollectionLine";
  return IconCollectionLine;
}(Component);

IconCollectionLine.glyphName = 'collection';
IconCollectionLine.variant = 'Line';
IconCollectionLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconCollectionLine;
export { IconCollectionLine };